import axios from "axios";
import queryString from "query-string";
// import loadConfig from "../apiService";
// import { decryptToken, encryptToken } from "./EncryptionToken";
import { jwtDecode } from "jwt-decode";
import { decryptToken, encryptToken } from "../Encryption/EncryptionToken";
import loadConfig from "../Api/ApiServices";


const LogInManagerServices = async () => {
  let config = await loadConfig();
  let userToken = "";
  
  function getCookieValue(cookieName) {
    const cookies = document.cookie.split("; ");
    //console.log(cookies, "cookies");

    for (let i = 0; i < cookies.length; i++) {
      const [name, value] = cookies[i].split("=");
      if (name === cookieName) {
        return value;
      }
    }
    return null; // إذا لم يتم العثور على الكوكي
  }
  const username = getCookieValue("loginTokenSSO");

  //console.log(username, "cookies.loginTokenSSO"); // يعرض قيمة الكوكي "username"

  try {
    // Check if tokens are stored in sessionStorage instead of cookies
    if (
      !sessionStorage.getItem("RefreshtokenManager") &&
      !sessionStorage.getItem("AccessTokenManager") &&
      username
    ) {
      //console.log(username, "11111111111111111111"); // يعرض قيمة الكوكي "username"

      // Perform login on your backend
      const loginResult = await axios.post(
        `${config.domainUrl}/api/Account/Login`,
        {
          nameSso: "internal",
          token: username,
        }
      );
      //console.log(loginResult, "loginResult");

      // Store tokens in sessionStorage instead of cookies
      var userInfo = jwtDecode(loginResult.data.result.accessToke);
      //     dispatch(SetDataUser(userInfo))
      var refreshToken = encryptToken(loginResult.data.result.refreshToken);
      var AccessToken = encryptToken(loginResult.data.result.accessToke);
      sessionStorage.setItem("RefreshtokenManager", refreshToken);
      sessionStorage.setItem("AccessTokenManager", AccessToken);
      userToken = userInfo;
      
      const RoleUser = await axios.post(
        `${config.domainUrl}/api/Account/GetRoleByUserGuid`,
        {
          uS_UserGuid: userInfo.UserGuid,
        }
      );

      let RoleUserId= RoleUser?.data?.result.map((ele) => ele?.rolesId);
     //Evaluator
      if(RoleUserId.includes("fd21937f-89d0-442e-8010-5b88e360bd48")){
              window.location.replace(config.redirect_uri+"SRFund/manager/RequestsEvaluation/");

      }
      //اللجنة العلمية
      else if(RoleUserId.includes("d9c9303e-2454-42b2-99e4-7f544b82b006")){
        window.location.replace(config.redirect_uri+"SRFund/manager/ScientificCommittee/");

      }
      //EmployeeAdvanceAction and EmployeeNormal
      else if(RoleUserId.includes("73c6d8f8-0796-4eeb-a788-383e5f63f8aa")||RoleUserId.includes("d9aa628b-c8ec-487b-8796-1293b942207a")){
        window.location.replace(config.redirect_uri+"SRFund/manager/TransferRequestsStatus/");

      }
    } else if (
      sessionStorage.getItem("RefreshtokenManager") &&
      sessionStorage.getItem("AccessTokenManager")&&username
    ) {
      userToken = jwtDecode(decryptToken("AccessTokenManager","manager"));
     
    } else {
      window.location.replace(config.internalSsoUrlreturn);
    
    }
  } catch (err) {
    //console.log("catch", err);
  }
  console.log({userToken:userToken,login:"manager"},"ssssswdwgggggggssssdwdwdwd");
  
  return {userToken:userToken,login:"manager"};
};

export default LogInManagerServices;
